import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { showSnackbar } from "../snackbar/Snackbar.slice";

const DOWNLOAD_FILES_FETCH = "downloadFiles/fetchFiles";
const DOWNLOAD_FILES_DOWNLOAD = "downloadFiles/downloadFile";
const DOWNLOAD_FILES_UPLOAD = "downloadFiles/uploadFile";

const API_BASE_URL = process.env.REACT_APP_API_ROUTE;

// Fetch list of files
export const fetchFiles = createAsyncThunk(
  DOWNLOAD_FILES_FETCH,
  async ({ token }, { rejectWithValue, dispatch }) => {
    try {
      // TODO: Replace with actual API endpoint
      // const url = "/files";

      // Mock data for now - remove when API is ready
      const mockFiles = [
        {
          id: "1",
          name: "report_2024_01.xlsx",
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          size: 245760, // bytes
          createdAt: "2024-01-15T10:30:00Z",
        },
        {
          id: "2",
          name: "transaction_log.pdf",
          type: "application/pdf",
          size: 1024000,
          createdAt: "2024-01-14T14:20:00Z",
        },
        {
          id: "3",
          name: "merchant_data.csv",
          type: "text/csv",
          size: 51200,
          createdAt: "2024-01-13T09:15:00Z",
        },
      ];

      // When API is ready, uncomment and use:
      // const response = await get(url, {
      //   headers: {
      //     Authorization: `Bearer ${token}`,
      //   },
      // });
      // return response.data || response;

      return mockFiles; // Remove this when API is ready
    } catch (error) {
      dispatch(
        showSnackbar({
          message: "Error fetching files list",
          severity: "error",
        })
      );
      return rejectWithValue({
        message: error.message || "Error fetching files",
      });
    }
  }
);

// Download a file
export const downloadFile = createAsyncThunk(
  DOWNLOAD_FILES_DOWNLOAD,
  async ({ fileId, fileName, token }, { rejectWithValue, dispatch }) => {
    try {
      // TODO: Replace with actual API endpoint
      const url = `${API_BASE_URL}/files/${fileId}/download`;

      // For file downloads, we need to use axios directly with responseType: 'blob'
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: "blob", // Important for file downloads
      });

      // Create a blob from the response
      const blob = new Blob([response.data], {
        type: response.headers["content-type"] || "application/octet-stream",
      });

      // Create a temporary URL and trigger download
      const url_blob = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url_blob;
      link.download = fileName || `file_${fileId}`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url_blob);

      dispatch(
        showSnackbar({
          message: `File "${fileName}" downloaded successfully`,
          severity: "success",
        })
      );

      return { fileId, fileName };
    } catch (error) {
      dispatch(
        showSnackbar({
          message: `Error downloading file: ${
            error.message || "Unknown error"
          }`,
          severity: "error",
        })
      );
      return rejectWithValue({
        message: error.message || "Error downloading file",
      });
    }
  }
);

// Upload a file
export const uploadFile = createAsyncThunk(
  DOWNLOAD_FILES_UPLOAD,
  async ({ file, token }, { rejectWithValue, dispatch }) => {
    try {
      // TODO: Replace with actual API endpoint
      const url = "/files/upload";

      const formData = new FormData();
      formData.append("file", file);

      // For file uploads with FormData, use axios directly
      const response = await axios.post(`${API_BASE_URL}${url}`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          // Don't set Content-Type, let the browser set it with boundary for FormData
        },
      });

      dispatch(
        showSnackbar({
          message: `File "${file.name}" uploaded successfully`,
          severity: "success",
        })
      );

      // Return the new file object
      return {
        id: response.data?.id || Date.now().toString(),
        name: file.name,
        type: file.type,
        size: file.size,
        createdAt: new Date().toISOString(),
      };
    } catch (error) {
      dispatch(
        showSnackbar({
          message: `Error uploading file: ${error.message || "Unknown error"}`,
          severity: "error",
        })
      );
      return rejectWithValue({
        message: error.message || "Error uploading file",
      });
    }
  }
);
